import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import { FaInfoCircle } from "react-icons/fa";
import { FaUserPlus } from "react-icons/fa6";
import Chip from "@mui/material/Chip";

import Img from "./svgImage/Avt12.png";
// import Img1 from "./Icon/air323.png";
// import Img1 from "./svgImage/updatedImg/Air India.webp";
// import Img1 from "./svgImage/updatedImg/FLIGHT BOOKING444.png";
import Img1 from "./svgImage/updatedImg/Flight Booking (6).png";
// import Banking from "./svgImage/Card_Info_Image/Banking (2).png";
import Banking from "./svgImage/updatedImg/PERSONAL BANKING 444.png";
// import Banking from "./svgImage/updatedImg/Personal Banking (2).png";
// import Cab from "./svgImage/Card_Info_Image/Cab (2).png";
// import Cab from "./svgImage/Card_Info_Image/cabIcon11.webp";
// import Cab from "./svgImage/updatedImg/Cab Booking.webp";
// import Cab from "./svgImage/updatedImg/CAB BOOKING 444.png";
import Cab from "./svgImage/updatedImg/Cab booking (5).png";
// import Cab from "./svgImage/Card_Info_Image/cabR1.webp";
// import Cab from "./svgImage/Card_Info_Image/carBook.webp";
import Ecommerce from "./svgImage/Card_Info_Image/E-commerce.png";
// import Ecommerce1 from "./svgImage/Card_Info_Image/E-Newspaper112.png";
// import Ecommerce1 from "./svgImage/updatedImg/E-NEWSPAPER 411.png";
import News from "./svgImage/updatedImg/E news papper.png";
// import Ecommerce1 from "./svgImage/updatedImg/E-Newspaper (2).png";
import Electricity from "./svgImage/Card_Info_Image/Electricity (5).png";
// import Electricity from "./svgImage/updatedImg/Electricity Department.webp";
// import Electricity from "./svgImage/updatedImg/ELECTRICITY BILL 22.png";
// import TelecomServices from "./svgImage/Card_Info_Image/Tele.png";
// import Education from "./svgImage/Card_Info_Image/Education (2).png";
// import TelecomServices from "./svgImage/updatedImg/Telecom Service_illustration_2ndpage.webp";
// import TelecomServices from "./svgImage/updatedImg/TELECOM SERVICES 22.png";
import TelecomServices from "./svgImage/updatedImg/TELECOM SERVICES 444.png";
import Education from "./svgImage/updatedImg/COLLEGE ADMISSION ASPIRANTS 22.png";
// import Education from "./svgImage/updatedImg/College Admission Aspirants. (2).png";
// import CarInsurance from "./svgImage/Card_Info_Image/car insu.png";
// import CarInsurance from "./svgImage/updatedImg/Car insurance_illustration_2ndpage.webp";
import CarInsurance from "./svgImage/updatedImg/CAR INSURANCE PREMIUM 444.png";
// import Broadcast from "./svgImage/Card_Info_Image/Broadcasting113.png";
import Broadcast from "./svgImage/updatedImg/IT COMPANY BROADCAST 444.png";
// import MovieTicket from "./svgImage/Card_Info_Image/Movie ticket.png";
import MovieTicket from "./svgImage/updatedImg/MOVIE TICKET BOOKNG 444.png";
// import HomeAutomation from "./svgImage/Card_Info_Image/Home auto.png";
import HomeAutomation from "./svgImage/updatedImg/HOME AUTOMATION 444.png";
// import Digmost from "./svgImage/Card_Info_Image/Dignost.png";
import Digmost from "./svgImage/updatedImg/DIAGNOSTICS SERVICES 22.png";
// import Notification from "./svgImage/Card_Info_Image/Notification.png";
import Notification from "./svgImage/updatedImg/PTA MEETING444.png";
// import Food from "./svgImage/Card_Info_Image/Food order (2).png";
import Food from "./svgImage/updatedImg/FOOD ORDERING 444.png";
// import ClickToAdd from "./svgImage/Card_Info_Image/Click to add.png";
import ClickToAdd from "./svgImage/updatedImg/ELECTION DUTY 444.png";

const CardInformationB2 = ({
  currentIndex,
  setCurrentIndex,
  setPmData,
  pmData,
}) => {
  const slides =
    pmData === 0
      ? [
          {
            id: 1,
            icon: News,
            title: "Subscribe to news on WhatsApp",
            description: "Get your daily news delivered straight to WhatsApp.",
            description1:
              "Choose your topics, pay once and get real-time updates!",
            paragraph: "#NewsOnWhatsApp",
            paragraph1: "#EnewsSubscription",
            paragraph2: "#WhatsAppNews",
            paragraph3: "#InstantUpdates",
          },
          {
            id: 2,
            icon: Img1,
            title: "Get your flight booked from WhatsApp",
            description: "From chat to boarding gate in minutes!",
            description1:
              "Get your flight booked while sipping coffee, all on WhatsApp.",
            paragraph: "#WhatsAppBookings",
            paragraph1: "#FlySmart ",
            paragraph2: "#WhatsAppYourFlight ",
            paragraph3: "#WhatsAppTravel",
          },
          {
            id: 3,
            icon: Cab,
            title: "WhatsApp is the new cab booking app",
            description: "Booking a cab just got smarter!",
            description1:
              "Pick your ride, pay in a chat and zoom off-effortlessly on WhatsApp.",
            paragraph: "#BookRideOnChat",
            paragraph1: "#WhatsAppTaxi",
            paragraph2: "#NoAppNoWait",
            paragraph3: "#RideWithAI",
          },
          {
            id: 4,
            icon: Banking,
            title: "Loan status? Just chat to know",
            description:
              "From loan approval to disbursement, it's all on WhatsApp!",
            description1:
              "Decide your amount, pay securely and receive your funds instantly.",
            paragraph: "#LoanProcessOnChat",
            paragraph1: "#BankingAutomation",
            paragraph2: " #OnlineLoanApply",
            paragraph3: "#WhatsAppPay",
          },
          {
            id: 5,
            icon: Electricity,
            title: "Power troubles? Let WhatsApp handle it",
            description:
              "Resolve electricity issues with a single WhatsApp message!",
            description1:
              "No calls, no waiting-Report faults instantly with just a photo and a chat.",
            paragraph: "#ComplaintOnChat",
            paragraph1: "#WhatsAppSupport",
            paragraph2: "#SmartService",
            paragraph3: "#UploadComplaintPhoto",
          },
        ]
      : pmData === 1
      ? [
          {
            id: 1,
            icon: TelecomServices,
            title: "Switch plans, not apps",
            description: "Skip the app, recharge with WhatsApp!",
            description1: "Choose your plan, pay and get recharged instantly!",
            paragraph: "#SmartTelecom",
            paragraph1: "#PayViaWhatsApp",
            paragraph2: "#InstantRecharge",
            paragraph3: "#TelecomOnChat",
          },
          {
            id: 2,
            icon: Education,
            title: "WhatsApp your way into college",
            description: "Start your college journey with a 'Hi'!",
            description1: "The new admission desk? It’s your chat screen.",
            paragraph: "#EducationOnChat",
            paragraph1: "#FastTrackAdmission",
            paragraph2: "#WhatsAppApplication",
            paragraph3: "#EasyEnrollment",
          },
          {
            id: 3,
            icon: CarInsurance,
            title: "Get car insurance service in a chat",
            description: "Your digital insurance assistant is here!",
            description1:
              "Check your details, pay securely and stay protected- all through WhatsApp.",
            paragraph: "#InsuranceOnWhatsApp",
            paragraph1: "#SecurePayments",
            paragraph2: "#CarInsuranceOnChat ",
            paragraph3: "#PolicyRenewal",
          },
          {
            id: 4,
            icon: Broadcast,
            title: "Get real-time meeting updates on WhatsApp",
            description:
              "Stay on track with WhatsApp -instant meeting details in your chat!",
            description1:
              "No more jumping between apps, get real-time updates and join in a tap.",
            paragraph: "#BroadcastOnWhatsApp",
            paragraph1: "#InstantMeetingUpdates",
            paragraph2: "#CRMIntegration",
            paragraph3: "#MeetingManagement",
          },
          {
            id: 5,
            icon: ClickToAdd,
            title: "Smart communication for smarter institutions",
            description: "Streamline school management with WhatsApp!",
            description1: "Broadcasting made easy for schools and departments.",
            paragraph: "#WhatsAppForSchools",
            paragraph1: "#SchoolBroadcast",
            paragraph2: "#WhatsAppForEducation",
            paragraph3: "#EfficientCommunication",
          },
        ]
      : [
          {
            id: 1,
            icon: Food,
            title: "Food that finds you in chat",
            description: "Food delivery, now a chat away!",
            description1:
              "Browse menus, customize your meal and place an order- all through WhatsApp.",
            paragraph: "#FoodOrderingOnChat",
            paragraph1: "#OrderMealsOnWhatsApp",
            paragraph2: "#WhatsAppFoodDelivery",
            paragraph3: "#OrderStatus",
          },
          {
            id: 2,
            icon: HomeAutomation,
            title: "Control home via WhatsApp",
            description: "Turn your home into a smart home with WhatsApp!",
            description1:
              "Adjust temperatures, lights and monitor your home- wherever you are.",
            paragraph: "#WhatsAppSmartHome",
            paragraph1: "#EnergyTracking",
            paragraph2: "#WhatsAppControl",
            paragraph3: "#HomeAutomation",
          },
          {
            id: 3,
            icon: Digmost,
            title: "Your health assistant is now on chat",
            description: "Get your test done with a single chat!",
            description1:
              "Book your test, select the package and get your results with ease.",
            paragraph: "#BookTestOnWhatsApp",
            paragraph1: "#InstantHealthcare",
            paragraph2: "#WhatsAppForHealth",
            paragraph3: "#ResultsOnChat",
          },
          {
            id: 4,
            icon: Notification,
            title: "PTM scheduling made effortless",
            description: "Stay updated with PTM meetings on WhatsApp!",
            description1:
              "Send reminders, confirm attendance and collect feedback-seamlessly in a chat.",
            paragraph: "#MeetingReminders",
            paragraph1: "#WhatsAppForParents",
            paragraph2: "#InstantSchoolUpdates",
            paragraph3: "#FeedbackFormOnline",
          },
          {
            id: 5,
            icon: MovieTicket,
            title: "Buy movie tickets instantly in chat",
            description: "Your cinema booking, now just a chat away!",
            description1:
              "Select, book and get your e-ticket delivered instantly to WhatsApp.",
            paragraph: "#BookMoviesOnChat",
            paragraph1: "#WebViewOnWhatsApp",
            paragraph2: "#SmartCinema",
            paragraph3: "#InstantBooking",
          },
        ];

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === slides.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        //  border: "2px solid red",
        width: "100%",
      }}
    >
      <Stack
        sx={{
          color: "#333",
          padding: { xl: "16px", lg: "16px", xs: "0px" },
          // backgroundColor: "rgba(255, 255, 255, 0.7)",
          // borderRadius: "8px",
          width: { xl: "80%", lg: "70%", md: "60%", sm: "100%" },
          marginLeft: { xl: "40px" },
          // border: "1px solid green",
        }}
      >
        <Typography
          sx={{
            color: pmData === 2 ? "#fff" : "rgb(5 78 146)",
            marginBottom: "10px",
            fontSize: {
              xs: "22px",
              sm: "26px",
              md: "30px",
              lg: "34px",
            },
            color: "#054E91",
            fontFamily: "'Roboto', sans-serif",
            fontWeight: 600,
            letterSpacing: "0.5px",
            textAlign: "left",
            //  border: "1px solid green",
          }}
        >
          {slides[currentIndex].title}
        </Typography>
        <Stack
          sx={{
            display: "flex",
            flexDirection: "column",
            color: pmData === 2 ? "rgba(255, 255, 255, 0.59)" : "#333",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              // marginBottom: "12px",
              fontSize: {
                xs: "15px",
                sm: "17px",
                md: "20px",
              },
              lineHeight: { xs: 1.5, sm: 1.8, md: 1.2 },
              fontFamily: "'Roboto', sans-serif",
              color: "text.secondary",
              fontWeight: "400",
              // border: "1px solid green",
            }}
          >
            {slides[currentIndex].description}
          </Typography>
          <Typography
            variant="h6"
            sx={{
              // color: "#333",
              marginBottom: "12px",
              fontSize: {
                xs: "15px",
                sm: "17px",
                md: "20px",
              },
              lineHeight: { xs: 1.5, sm: 1.8, md: 1.2 },
              fontFamily: "'Roboto', sans-serif",
              color: "text.secondary",
              fontWeight: "400",
              // border: "1px solid green",
            }}
          >
            {slides[currentIndex].description1}
          </Typography>
        </Stack>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "20px",
            fontSize: {
              xl: "20px",
              lg: "20px",
              md: "20px",
              sm: "12px",
              xs: "12px",
            },
            lineHeight: { xl: "20px" },
            marginTop: "10px",
            //  border: "1px solid green",
          }}
        >
          {/* {slides[currentIndex].paragraph} */}
          <Chip
            label={slides[currentIndex].paragraph}
            sx={{
              marginRight: { xl: "12px", lg: "12px", md: "12px", sm: "8px" },
              borderRadius: "6px",
              color: "#fff",
              backgroundColor: "rgb(5 78 146)",
              // backgroundColor: "#a8d9f5ff",
              fontWeight: "500",
              // boxShadow: "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",
            }}
          />
          <Chip
            label={slides[currentIndex].paragraph1}
            sx={{
              marginRight: { xl: "10px", lg: "10px", md: "10px", sm: "8px" },
              borderRadius: "6px",
              color: "#fff",
              backgroundColor: "rgb(5 78 146)",
              // backgroundColor: "#a8d9f5ff",
              fontWeight: "500",
              // boxShadow: "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",
            }}
          />
          <Chip
            label={slides[currentIndex].paragraph2}
            sx={{
              marginRight: { xl: "10px", lg: "10px", md: "10px", sm: "8px" },
              borderRadius: "6px",
              color: "#fff",
              backgroundColor: "rgb(5 78 146)",
              // backgroundColor: "#a8d9f5ff",
              fontWeight: "500",
              // boxShadow: "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",
            }}
          />
          <Chip
            label={slides[currentIndex].paragraph3}
            sx={{
              marginRight: { xl: "10px", lg: "10px", md: "10px", sm: "8px" },
              borderRadius: "6px",
              color: "#fff",
              backgroundColor: "rgb(5 78 146)",
              // backgroundColor: "#a8d9f5ff",
              fontWeight: "500",
              // boxShadow: "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",
            }}
          />
        </Typography>
        <Stack direction="row" spacing={2} sx={{}}>
          {/* <Button
            variant="contained"
            startIcon={<FaUserPlus />}
            sx={{
              backgroundColor: "rgb(31,133,192)",
              textTransform: "none",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",
            }}
            size="large"
          >
            Sign up now
          </Button> */}
          {/* <Button
            variant="outlined"
            startIcon={<FaUserPlus style={{ color: "white" }} />}
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              backgroundColor: "rgb(5, 78, 146)", // Initial background
              color: "white", // Text color
              borderColor: "rgb(5, 78, 146)", // Border same as background
              boxShadow: "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",

              "&:hover": {
                backgroundColor: "rgb(31, 133, 192)", // Hover background
                borderColor: "rgb(31, 133, 192)", // Hover border
              },
            }}
            size="large"
          >
            Sign up now
          </Button>
          <Button
            variant="outlined"
            startIcon={<FaInfoCircle style={{ color: "rgb(5, 78, 146)" }} />}
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              color: "rgb(5, 78, 146)",
              borderColor: "rgb(5, 78, 146)",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",
            }}
            size="large"
          >
            Know more
          </Button> */}
        </Stack>
      </Stack>

      <Stack
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: {
            xl: "center",
            lg: "flex-end",
            md: "flex-end",
            sm: "center",
            xs: "center",
          },
          width: "30%",
          width: { xl: "20%", lg: "30%", md: "30%" },
          gap: "20px",
          // border: "1px solid red",
          marginRight: {
            xl: "25px",
            lg: "5px",
            md: "2px",
            sm: "2px",
            xs: "0px",
          },
        }}
      >
        <Stack
          sx={{
            height: "238px",
            width: "238px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={slides[currentIndex].icon}
            alt="topImg"
            style={{ height: "100%", width: "100%", objectFit: "contain" }}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default CardInformationB2;
